<template>
  <div class="uk-card-small uk-card-default">
    <div class="uk-card-header">
      <h4 v-if="isOceanExport">Ocean Export Order Reference</h4>
      <h4 v-else-if="isLand">Land Order Reference</h4>
      <h4 v-else-if="isRailPickUp">Rail Pick-Up Reference</h4>
      <h4 v-else-if="isRailDropOff">Rail Delivery Reference</h4>
      <h4 v-else>Ocean Import Order Reference</h4>
    </div>
    <div class="uk-card-body">
      <div uk-grid>
        <div class="uk-width-1-1">
          <div uk-grid>
            <div class="uk-width-1-3" v-if="isOceanExport || isOceanImport">
              <div v-if="isOceanExport">
                <InputField
                  v-model="orderData.bookingNumber"
                  id="bkgNumber"
                  label="Booking Number"
                ></InputField>
              </div>
              <div v-else-if="isOceanImport">
                <label for="blNumber" class="uk-form-label">Bill of Lading Number</label>
                <FilterableDropdown
                  taggable
                  push-tag
                  v-model="orderData.billOfLadingNumber"
                  :options="mappedBLs"
                  @input="selectBL"
                  :components="{ OpenIndicator: null, Deselect: null }"
                ></FilterableDropdown>

                <p
                  v-if="
                    orderData.billOfLadingNumber &&
                      orderData.billOfLadingNumber.length > 4 &&
                      !doesBLExist()
                  "
                  class="uk-margin-remove uk-text-primary"
                >
                  Bill of Lading does not exist, will create a new Bill of Lading
                  {{ orderData.billOfLadingNumber }}
                </p>
                <p
                  v-else-if="
                    orderData.billOfLadingNumber &&
                      orderData.billOfLadingNumber.length > 4 &&
                      doesBLExist()
                  "
                  class="uk-margin-remove uk-text-success"
                >
                  Already Tracking
                  {{ activeBLs[mappedBLs.indexOf(orderData.billOfLadingNumber)].containers.length }}
                  containers for BL
                </p>
              </div>
            </div>
            <InputField
              :class="{
                'uk-width-1-3': isOceanImport || isOceanExport || isLand,
                'uk-width-1-2': isRailPickUp || isRailDropOff,
              }"
              id="CustomerRef"
              label="Customer Reference #"
              v-model="orderData.customerReference"
            ></InputField>
            <InputField
              :class="{
                'uk-width-1-3': isOceanImport || isOceanExport || isLand,
                'uk-width-1-2': isRailPickUp || isRailDropOff,
              }"
              id="CustomerRef"
              label="Billing Reference #"
              v-model="orderData.billingCustomerReference"
            ></InputField>
            <InputField
              v-if="settingsOrderShowLinkedOrderNumberField"
              class="uk-width-1-3"
              id="LinkedOrderNumber"
              label="Linked Master Order #"
              v-model="orderData.linkedMasterOrderNumber"
            ></InputField>
            <InputField
              v-if="showBrokerFields"
              class="uk-width-1-3 uk-margin-remove-top"
              id="HouseBillOfLading"
              label="House Bill of Lading Number"
              v-model="orderData.houseBillOfLading"
            ></InputField>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InputField from '../../core/Input/InputField.vue';
import FilterableDropdown from '../../core/FilterableDropdown.vue';
import { SteamShipLinesMap, SteamShipLines } from '../../../utils/constants';
import { blExistsInActiveBls, findActiveBl } from '@/utils/active_BLs_apollo';

export default defineComponent({
  props: {
    mappedBLs: {
      required: true,
    },
    orderData: {
      required: true,
    },
    isOceanExport: {
      required: true,
    },
    isOceanImport: {
      required: true,
    },
    isLand: {
      required: true,
    },
    isRailPickUp: {
      default: false,
    },
    isRailDropOff: {
      default: false,
    },
    settingsOrderShowLinkedOrderNumberField: {
      required: true,
    },
    showBrokerFields: {
      required: true,
    },
    activeBLs: {
      required: true,
    },
  },
  components: {
    FilterableDropdown,
  },
  methods: {
    doesBLExist(): boolean {
      const vm = (this as any);
      return blExistsInActiveBls(vm.activeBLs, (vm.orderData as any).billOfLadingNumber);
    },
    selectBL(val) {
      const vm = (this as any);
      const activeBl = findActiveBl(vm.activeBLs, val);
      if (activeBl) {

        console.log(
          `Selected BL ${val} ${JSON.stringify(activeBl)} user Bls is ${JSON.stringify(
            vm.activeBLs,
          )}`,
        );

        const containers = activeBl.containers.slice();
        (vm.orderData as any).containers = containers.map((x) => {
          const { id, ...dat } = x;

          dat.freightContents = dat.freightContents.map((y) => {
            return {
              quantity: y.cargoPieces,
              packingType: y.packingType,
              isHazmat: y.isHazmat,
              weight: y.weight,
              description: y.cargoDescription,
              nmfcNumber: y.nmfcNumber,
              nmfcClass: y.nmfcClass,
            };
          });
          return dat;
        });

        if (activeBl.pickUpLocation === 'TRAPAC') {
          (vm.orderData as any).pickUpTerminal = 'TraPac';
        } else {
          (vm.orderData as any).pickUpTerminal = activeBl.pickUpLocation;
        }

        if (activeBl.latestVessel) {
          (vm.orderData as any).shipLineInfo.vessel = activeBl.latestVessel.name;
        }
      }

      // console.log(`bl is now ${val}`);
      // # TODO: STANDARDIZE_SCAC_CODES
      if (val.includes('HLCU')) {
        (vm.orderData as any).shipLineInfo.line = 'Hapag-Lloyd';
      } else if (val.includes('ONEY')) {
        (vm.orderData as any).shipLineInfo.line = 'One Line';
      } else if (val.includes('HDMU')) {
        (vm.orderData as any).shipLineInfo.line = 'Hyundai Merchant';
      } else if (val.includes('EGLV')) {
        (vm.orderData as any).shipLineInfo.line = 'Evergreen';
      } else if (val.includes('ZIMU')) {
        (vm.orderData as any).shipLineInfo.line = 'ZIM Intergrated';
      } else if (val.includes('MEDU')) {
        (vm.orderData as any).shipLineInfo.line = 'MEDU (Mediterranian Shipping)';
      } else if (val.includes('CMDU')) {
        (vm.orderData as any).shipLineInfo.line = 'CMA CGM';
      } else if (val.includes('YMLU') || val.includes('Yang Ming')) {
        (vm.orderData as any).shipLineInfo.line = 'YMLU (Yang Ming)';
      } else if (val.includes('APL')) {
        (vm.orderData as any).shipLineInfo.line = 'APLU (American President Lines)';
      } else if (val.includes('OOLU')) {
        (vm.orderData as any).shipLineInfo.line = 'OOCL (Orient Overseas Container Line)';
      } else if (val.includes('MAEU')) {
        (vm.orderData as any).shipLineInfo.line = SteamShipLinesMap.MAEU;
      } else if (val.includes('WHLU')) {
        (vm.orderData as any).shipLineInfo.line = SteamShipLinesMap.WHLU;
      } else if (val.includes('SUDU')) {
        (vm.orderData as any).shipLineInfo.line = SteamShipLinesMap.SUDU;
      } else if (val.includes('SAFM')) {
        (vm.orderData as any).shipLineInfo.line = SteamShipLinesMap.SAFM;
      }
    },
  },
});
</script>
